import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    countryCode: window.country,
    order: undefined,
    addresses: [],
    stores: [],
    shippingMethods: [],
    email: undefined,
    selectedShippingMethod: undefined,
    shippingAddress: undefined,
    packagingList: [],
    adyenPaymentMethodsResponse: undefined,
    adyenConfig: undefined,
    paymentError: undefined,
    checkoutConfig: undefined,
    deliverydates: [],
    deliveryslots: [],
    loading: false,
    promoCodeError: undefined,
    giftCardsApplied: [],
    orderTotal: null,
    isBOB: false,
};
export default createSlice({
    name: 'checkout',
    initialState: initialState,
    reducers: {
        updateCheckoutData: (state, action) => {
            state.customer = action.payload.customer;
            state.checkoutConfig = action.payload.checkoutConfig;
            state.adyenConfig = action.payload.adyenConfig;
            state.packagingList = action.payload.packagingList;
            state.isBOB = action.payload.isBOB;
        },
        updatePBLCheckoutData: (state, action) => {
            state.customer = action.payload.customer;
            state.checkoutConfig = action.payload.checkoutConfig;
            state.adyenConfig = action.payload.adyenConfig;
            state.packagingList = action.payload.packagingList;
            state.orderTotal = action.payload.orderTotal;
        },
        updateOrder: (state, action) => {
            var _a;
            let order = action.payload;
            if ((_a = order === null || order === void 0 ? void 0 : order.items) === null || _a === void 0 ? void 0 : _a.items) {
                order.items = order.items.items;
            }
            state.order = order;
            if ((order === null || order === void 0 ? void 0 : order.shipping) && (order === null || order === void 0 ? void 0 : order.shipping.length) > 0) {
                let shipping = order === null || order === void 0 ? void 0 : order.shipping[0];
                state.selectedShippingMethod = shipping === null || shipping === void 0 ? void 0 : shipping.selectedShippingMethod;
                state.shippingAddress = shipping === null || shipping === void 0 ? void 0 : shipping.shippingAddress;
                state.shippingMethods = shipping === null || shipping === void 0 ? void 0 : shipping.applicableShippingMethods;
                state.deliveryslots = shipping === null || shipping === void 0 ? void 0 : shipping.deliveryslots;
                state.deliverydates = shipping === null || shipping === void 0 ? void 0 : shipping.deliverydates;
            }
            else {
                state.shippingAddress = undefined;
            }
            if (order === null || order === void 0 ? void 0 : order.orderEmail) {
                state.email = order.orderEmail;
            }
        },
        updateAddresses: (state, action) => {
            state.addresses = action.payload;
        },
        updateShippingAddress: (state, action) => {
            state.shippingAddress = action.payload;
        },
        updatePaymentMethods: (state, action) => {
            state.adyenPaymentMethodsResponse = action.payload;
        },
        updateShippingMethods: (state, action) => {
            state.shippingMethods = action.payload;
        },
        updateCustomer: (state, action) => {
            state.customer = action.payload;
        },
        updateEmail: (state, action) => {
            state.email = action.payload;
        },
        updatePaymentError: (state, action) => {
            state.paymentError = action.payload;
        },
        updatePickupData: (state, action) => {
            var _a;
            state.stores = ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.stores) || [];
        },
        updateCountryCode: (state, action) => {
            state.countryCode = action.payload;
        },
        updateLoading: (state, action) => {
            state.loading = action.payload;
        },
        setPromoCodeError: (state, action) => {
            state.promoCodeError = action.payload;
        },
        resetPromoCodeError: (state) => {
            state.promoCodeError = null;
        },
        updateIsFetching: (state, action) => {
            state.isFetchingData = action.payload;
        },
        updateGiftCardsApplied: (state, action) => {
            state.giftCardsApplied = action.payload;
        },
    },
});
